import React from 'react';
import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import Close (X) Icon
import { Map } from '../../../components/map/Map.js' // Assuming Map is the component for displaying paths on the map
import useAuth from '../../../hooks/Auth/useAuth.js';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'hidden',
    position: 'relative', // This ensures the close button is positioned relative to the modal content
};

const closeButtonStyle = {
    position: 'absolute',
    top: 8, // Adjust the position from the top of the modal
    right: 8, // Adjust the position from the right of the modal
    zIndex: 1, // Ensure it's above other elements
    width: '30px',  // Adjust button size
    height: '30px',
};

const RoadPreviewModal = ({ roadRecording = null, open, onClose }) => {

    const {bounderiesStorage, roadsStorage } = useAuth();
                
    if (!roadRecording) return null;


    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                {/* Close (X) Button */}
                <IconButton aria-label="close" sx={closeButtonStyle} onClick={onClose} size="large">
                    <CloseIcon fontSize="small" />
                </IconButton>

                {/* Map Component */}
                <Map
                    isShuttleComponent={true}
                    showBoundaries={true}
                    showRoads={true}
                    pathWeight="8"
                    bounderiesList={bounderiesStorage}
                    roadsList={roadsStorage}
                    mapHeight="100%" // Full height of the modal
                    isPreview={true}
                    showRoadRecordingHistory={true}
                    showStartEndMarkers={true} // Show start/end markers for tour
                    roadRecordingHistory={{...roadRecording, points: roadRecording?.pathPoints || []}} // Pass the road recording history

                />
            </Box>
        </Modal>
    );
};

export default RoadPreviewModal;
